import { useTranslation } from 'react-i18next'
import { Globe } from 'lucide-react'
import { SUPPORTED_LANGUAGES, type SupportedLanguage } from '@/i18n'
import { useTenantStore } from '@/store/tenantStore'

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation('common')
  const tenantInfo = useTenantStore((state) => state.tenantInfo)

  // languageMode가 'both'일 때만 토글 노출 (ko/en 단일 모드, null/unknown 전부 숨김)
  if (tenantInfo?.languageMode !== 'both') {
    return null
  }

  const currentLang = (SUPPORTED_LANGUAGES.includes(i18n.language as SupportedLanguage)
    ? i18n.language
    : 'ko') as SupportedLanguage

  const nextLang: SupportedLanguage = currentLang === 'ko' ? 'en' : 'ko'

  const handleToggle = () => {
    i18n.changeLanguage(nextLang)
  }

  return (
    <button
      onClick={handleToggle}
      className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-sm font-medium transition-colors bg-gray-100 hover:bg-gray-200 text-gray-700"
      title={t(`language.${nextLang}`)}
    >
      <Globe className="w-4 h-4" />
      <span>{currentLang.toUpperCase()}</span>
    </button>
  )
}
